/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Noperiodtocompare3Inputs */

const en_analytics_noperiodtocompare3 = /** @type {(inputs: Analytics_Noperiodtocompare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No period to compare`)
};

/**
* | output |
* | --- |
* | "No period to compare" |
*
* @param {Analytics_Noperiodtocompare3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_noperiodtocompare3 = /** @type {((inputs?: Analytics_Noperiodtocompare3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Noperiodtocompare3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_noperiodtocompare3(inputs)
});
export { analytics_noperiodtocompare3 as "analytics_noPeriodToCompare" }